import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-selected"]
const _hoisted_2 = { class: "min-w-0" }
const _hoisted_3 = {
  key: 0,
  class: "mt-0.5 text-sm text-gray-600"
}
const _hoisted_4 = ["aria-checked", "disabled"]

import { useId } from 'vue'


export default {
  __name: 'ToggleRow',
  props: {
  modelValue: { type: Boolean, default: false },
  title: { type: String, required: true },
  description: { type: String, default: '' },
  disabled: { type: Boolean, default: false }
},
  emits: ['update:modelValue'],
  setup(__props) {




const titleId = `toggle-${useId()}`

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-option": "",
    "data-selected": String(__props.modelValue),
    class: "flex items-center justify-between gap-5 py-3.5"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        id: titleId,
        "data-option-title": "",
        class: "text-sm font-semibold text-gray-900"
      }, _toDisplayString(__props.title), 1),
      (__props.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.description), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      type: "button",
      role: "switch",
      "aria-checked": String(__props.modelValue),
      "aria-labelledby": titleId,
      disabled: __props.disabled,
      class: _normalizeClass(["relative h-[26px] w-11 flex-shrink-0 rounded-full p-0 transition-colors focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900 disabled:cursor-not-allowed disabled:opacity-50", __props.modelValue ? 'bg-gray-600' : 'bg-gray-200']),
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('update:modelValue', !__props.modelValue)))
    }, [
      _createElementVNode("span", {
        "aria-hidden": "true",
        class: _normalizeClass(["absolute top-[3px] h-5 w-5 rounded-full bg-white shadow transition-all", __props.modelValue ? 'left-[21px]' : 'left-[3px]'])
      }, null, 2)
    ], 10, _hoisted_4)
  ], 8, _hoisted_1))
}
}

}